import { Divider, Input } from 'antd';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledColorMenu = styled.div.withConfig({
  displayName: "color-table-menucomponent__StyledColorMenu",
  componentId: "sc-1bikb89-0"
})(["width:240px;background-color:white;border:1px solid #ccc;border-radius:4px;box-shadow:0 2px 4px rgba(0,0,0,0.2);padding:8px;"]);
var StyledColorWrapper = styled.div.withConfig({
  displayName: "color-table-menucomponent__StyledColorWrapper",
  componentId: "sc-1bikb89-1"
})(["display:grid;grid-template-columns:repeat(10,1fr);gap:2px;"]);
var colors = ['#FF0000', '#FF4500', '#FF6347', '#FF7F50', '#FF8C00', '#FFA500', '#FFD700', '#FFFF00', '#ADFF2F', '#7FFF00', '#7CFC00', '#00FF00', '#32CD32', '#00FA9A', '#00FF7F', '#3CB371', '#2E8B57', '#228B22', '#008000', '#006400', '#66CDAA', '#8FBC8F', '#20B2AA', '#008B8B', '#008080', '#00CED1', '#40E0D0', '#48D1CC', '#00FFFF', '#00BFFF', '#1E90FF', '#4169E1', '#0000FF', '#0000CD', '#00008B', '#000080', '#191970', '#8A2BE2', '#4B0082', '#6A5ACD', '#7B68EE', '#9370DB', '#8B008B', '#9400D3', '#9932CC', '#BA55D3', '#DDA0DD', '#EE82EE', '#FF00FF', '#DA70D6', '#C71585', '#DB7093', '#FF1493', '#FF69B4', '#FFB6C1', '#FFC0CB', '#FA8072', '#E9967A', '#F08080', '#CD5C5C', '#DC143C', '#B22222', '#A52A2A', '#8B0000', '#800000', '#FAEBD7', '#F5F5DC', '#FFE4C4', '#FFEBCD', '#F5DEB3', '#FFF8DC', '#FFFACD', '#FAFAD2', '#FFFFE0', '#FFFFF0', '#F0FFF0', '#F5FFFA', '#F0FFFF', '#F0F8FF', '#E6E6FA'];
var basicColors = ['#FFFFFF', '#000000'];
var ColorCircle = styled.div.withConfig({
  displayName: "color-table-menucomponent__ColorCircle",
  componentId: "sc-1bikb89-2"
})(["width:18px;height:18px;border-radius:50%;background-color:", ";cursor:pointer;", " border:1px solid #e9e9e9;&:hover{border:1px solid #ccc;}"], function (_ref) {
  var color = _ref.color;
  return color;
}, function (props) {
  return props.border && 'border: 1px solid #e9e9e9;';
});
export var ColorTableMenu = function ColorTableMenu(_ref2) {
  var editor = _ref2.editor,
      labels = _ref2.labels,
      onSelectColor = _ref2.onSelectColor;
  return /*#__PURE__*/_jsxs(StyledColorMenu, {
    children: [/*#__PURE__*/_jsx(StyledColorWrapper, {
      children: colors.map(function (color) {
        return /*#__PURE__*/_jsx(ColorCircle, {
          color: color,
          onClick: function onClick() {
            return onSelectColor(color);
          }
        }, color);
      })
    }), /*#__PURE__*/_jsx(Divider, {
      orientation: "left",
      children: labels.basicColors
    }), /*#__PURE__*/_jsx(StyledColorWrapper, {
      children: basicColors.map(function (color) {
        return /*#__PURE__*/_jsx(ColorCircle, {
          color: color,
          onClick: function onClick() {
            return onSelectColor(color);
          },
          border: true
        }, color);
      })
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Input, {
      type: "color",
      onInput: function onInput(event) {
        return onSelectColor(event.currentTarget.value);
      },
      value: editor.getAttributes('textStyle').color
    })]
  });
};